import React from "react";

const Workshop = () => {
  return (
    <div className="container mt-5 mb-5 pt-5">
      <h3 className="text-center text-uppercase mb-5">Upcoming Workshops</h3>
      <div className="d-flex justify-content-between flex-wrap">
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Jihad Chowdhory</div>
          <div className="card-body">
            <h5 className="card-title">On Skill Dev</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">15 JAN 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by James</div>
          <div className="card-body">
            <h5 className="card-title">On Startup</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">1st FEB 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Jihad Chowdhory</div>
          <div className="card-body">
            <h5 className="card-title">On Carrier Dev</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">15 FEB 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Ashraful Islam</div>
          <div className="card-body">
            <h5 className="card-title">On Case Study</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">1st MAR 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Akash</div>
          <div className="card-body">
            <h5 className="card-title">On Business Studies</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">15 MAR 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured By Showrab Mirza</div>
          <div className="card-body">
            <h5 className="card-title">On Spoken English</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">1st APR 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Jihad</div>
          <div className="card-body">
            <h5 className="card-title">On Healthy Life</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">15 APR 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Elon Musk</div>
          <div className="card-body">
            <h5 className="card-title">On Taking Risk</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">1st MAY 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Mark Zukerburg</div>
          <div className="card-body">
            <h5 className="card-title">On App Dev</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">15 MAY 2022</div>
        </div>
        <div className="card text-center mt-4">
          <div className="card-header">Featured by Lary Paige</div>
          <div className="card-body">
            <h5 className="card-title">On Data Stucture</h5>
            <a href="#q" className="btn btn-dark">
              Book Now
            </a>
          </div>
          <div className="card-footer text-muted">1st JUN 2022</div>
        </div>
      </div>
    </div>
  );
};

export default Workshop;
